import { useEffect, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import { getFieldByTitle } from '../../../helpers/sortByTitle';
import { selectedFilterItems } from '../../../helpers/filter';
export interface Payment {
  groupId: string;
  totalCost: number;
  // paymentWay: string;
  checkoutId: string;
  createdAt: string;
  paymentStatus: 'ACCEPTED' | 'REFUNDED';
}
export interface Subscription {
  _id: string;
  extra: number;
  numOfTickets: number;
  charity: string;
  raffle: any;
  subscriptionModel: any;
  refference: string;
  totalCost: number;
  // paymentWay: string;
  checkoutId: string;
  purchaseDate?: Date;
  nextPurchaseDate?: Date;
  createdAt: string;
  status: string;
}

export const useSubscriptionModels = () => {
  const [state, setState] = useState<any>({
    subscriptionModels: [],
  });
  const [bankedDialog, setBankedDialog] = useState({
    isOpen: false,
    activePayment: undefined,
  });
  const [filter, setFilter] = useState({
    searchField: '',
    status: [
      { id: 'REFUNDED', title: 'REFUNDED', isActive: true },
      { id: 'ACCEPTED', title: 'ACCEPTED', isActive: true },
    ],
    selectedStatuts: Array<string>(),
  });
  const [searchState, setSearchState] = useState({
    groupId: '',
  });
  const [dropdown, setDropdown] = useState({
    groupid: false,
    status: false,
  });

  const dataProvider = useDataProvider();
  const notify = useNotify();

  const closeBankedDialog = () =>
    setBankedDialog((state) => ({ ...state, isOpen: false }));

  useEffect(() => {
    getSubscriptionModels();
  }, []);

  const getSubscriptionModels = async () => {
    const { data } = await dataProvider.getSubscriptionModels();
    console.log(data);
    setState({ ...state, subscriptionModels: data.subscriptionModels });
  };
  const addSubscription = async (values: any) => {
    try {
      const { data }: any = await dataProvider.addSubscriptionModel(values);
      if (data) {
        notify(data.message, 'info');
        const newSubscriptions = [...state.subscriptionModels];
        newSubscriptions.push(data.subscriptionModel);
        setState({
          ...state,
          subscriptionModels: newSubscriptions,
        });
      }
    } catch (err: any) {
      console.log(err);
      notify(err.toString(), 'info');
    }
  };
  const updateSubscription = async (id: string, data: any) => {
    const res = await dataProvider.updateSubscriptionModel({ id, data });
    console.log(res);
  };
  const updateSubscriptionMonth = async (id: string, data: any) => {
    const res = await dataProvider.updateSubscriptionModelMonth({ id, data });
    console.log(res);
  };
  const addSubscriptionMonth = async (id: string, paylad: any) => {
    try {
      const { data } = await dataProvider.addSubscriptionModelMonth({
        id,
        data: paylad,
      });
      console.log(data);
      if (data) {
        notify('Added new month', 'info');
        let newSubModels = [...state.subscriptionModels];
        let indexOfUpdated = state.subscriptionModels.findIndex(
          (item) => item._id === data._id
        );
        if (indexOfUpdated >= 0) {
          console.log('FINDED');
          newSubModels[indexOfUpdated] = { ...data };
          setState({
            ...state,
            subscriptionModels: newSubModels,
          });
        }
      }
    } catch (err) {}
  };
  const filterDropdown = (title: string) => {
    const titleArray = title.toLowerCase().split(' ');
    setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] });
  };
  const closeFilter = (e: any) => {
    setDropdown((state) => ({ ...state, groupid: false }));
  };

  const search = (value: string, field: string) => {
    setSearchState({ ...searchState, [field]: value });
  };

  const clearSearch = (clear: string) => {
    setSearchState({ ...searchState, [clear]: '' });
  };

  return {
    state,
    bankedDialog,
    setBankedDialog,

    filterDropdown,
    closeFilter,
    dropdown,
    search,
    searchState,
    clearSearch,
    closeBankedDialog,
    filter,
    addSubscription,
    updateSubscription,
    addSubscriptionMonth,
    updateSubscriptionMonth,
  };
};
